import {
  TransformingSequence3gzv034v2j93f as TransformingSequence,
  FilteringSequence3rfik2d45zn1y as FilteringSequence,
  FlatteningSequence1gb46kmahgjp0 as FlatteningSequence,
  TakeSequencecj2mz1r3ww35 as TakeSequence,
  DropTakeSequence18qfczyunxcax as DropTakeSequence,
  emptySequence25zpp7hgtqwdd as emptySequence,
  DistinctSequence1lbisrkxedews as DistinctSequence,
} from './Sequences.mjs';
import {
  sequence2vgswtrxvqoa7 as sequence,
  SequenceScope1coiso86pqzq2 as SequenceScope,
} from './SequenceBuilder.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../text/StringBuilderJs.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../collections/CollectionsKt.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  setOf1u3mizs95ngxo as setOf,
  sortWith4fnm6b3vw03s as sortWith,
} from '../collections/collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../js/compareTo.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../collections/Sets.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../collections/LinkedHashSet.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { Sequence1quqbxersk0bb as Sequence } from './Sequence.mjs';
import { appendElement7nmjunfw9r4 as appendElement } from '../text/Appendable.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { Iterable1y3qizuf89iou as Iterable } from '../collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function firstOrNull(_this__u8e3s4) {
  var iterator = _this__u8e3s4.m1();
  if (!iterator.n1())
    return null;
  return iterator.o1();
}
function mapNotNull(_this__u8e3s4, transform) {
  return filterNotNull(new (TransformingSequence())(_this__u8e3s4, transform));
}
function filter(_this__u8e3s4, predicate) {
  return new (FilteringSequence())(_this__u8e3s4, true, predicate);
}
function sum(_this__u8e3s4) {
  var sum = 0.0;
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    sum = sum + element;
  }
  return sum;
}
function zipWithNext(_this__u8e3s4, transform) {
  return sequence(zipWithNext$slambda_0(_this__u8e3s4, transform));
}
function joinToString(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
  separator = separator === VOID ? ', ' : separator;
  prefix = prefix === VOID ? '' : prefix;
  postfix = postfix === VOID ? '' : postfix;
  limit = limit === VOID ? -1 : limit;
  truncated = truncated === VOID ? '...' : truncated;
  transform = transform === VOID ? null : transform;
  return joinTo(_this__u8e3s4, StringBuilder().d1(), separator, prefix, postfix, limit, truncated, transform).toString();
}
function flatMap(_this__u8e3s4, transform) {
  return new (FlatteningSequence())(_this__u8e3s4, transform, Sequence$iterator$ref());
}
function map(_this__u8e3s4, transform) {
  return new (TransformingSequence())(_this__u8e3s4, transform);
}
function toList(_this__u8e3s4) {
  var it = _this__u8e3s4.m1();
  if (!it.n1())
    return emptyList();
  var element = it.o1();
  if (!it.n1())
    return listOf(element);
  var dst = ArrayList().w();
  dst.v(element);
  while (it.n1()) {
    dst.v(it.o1());
  }
  return dst;
}
function maxOrNull(_this__u8e3s4) {
  var iterator = _this__u8e3s4.m1();
  if (!iterator.n1())
    return null;
  var max = iterator.o1();
  while (iterator.n1()) {
    var e = iterator.o1();
    if (compareTo(max, e) < 0)
      max = e;
  }
  return max;
}
function toSet(_this__u8e3s4) {
  var it = _this__u8e3s4.m1();
  if (!it.n1())
    return emptySet();
  var element = it.o1();
  if (!it.n1())
    return setOf(element);
  var dst = LinkedHashSet().v1();
  dst.v(element);
  while (it.n1()) {
    dst.v(it.o1());
  }
  return dst;
}
function take(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().a1(toString(message));
  }
  var tmp;
  if (n === 0) {
    tmp = emptySequence();
  } else {
    if (isInterface(_this__u8e3s4, DropTakeSequence())) {
      tmp = _this__u8e3s4.n2(n);
    } else {
      tmp = new (TakeSequence())(_this__u8e3s4, n);
    }
  }
  return tmp;
}
function asIterable(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new (asIterable$$inlined$Iterable$1())(_this__u8e3s4);
}
function filterNotNull(_this__u8e3s4) {
  var tmp = filterNot(_this__u8e3s4, filterNotNull$lambda);
  return isInterface(tmp, Sequence()) ? tmp : THROW_CCE();
}
function joinTo(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
  separator = separator === VOID ? ', ' : separator;
  prefix = prefix === VOID ? '' : prefix;
  postfix = postfix === VOID ? '' : postfix;
  limit = limit === VOID ? -1 : limit;
  truncated = truncated === VOID ? '...' : truncated;
  transform = transform === VOID ? null : transform;
  buffer.e1(prefix);
  var count = 0;
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  $l$loop: while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    count = count + 1 | 0;
    if (count > 1) {
      buffer.e1(separator);
    }
    if (limit < 0 || count <= limit) {
      appendElement(buffer, element, transform);
    } else
      break $l$loop;
  }
  if (limit >= 0 && count > limit) {
    buffer.e1(truncated);
  }
  buffer.e1(postfix);
  return buffer;
}
function filterNot(_this__u8e3s4, predicate) {
  return new (FilteringSequence())(_this__u8e3s4, false, predicate);
}
function distinct(_this__u8e3s4) {
  return distinctBy(_this__u8e3s4, distinct$lambda);
}
function flatMap_0(_this__u8e3s4, transform) {
  return new (FlatteningSequence())(_this__u8e3s4, transform, Iterable$iterator$ref());
}
function sortedWith(_this__u8e3s4, comparator) {
  return new (sortedWith$1())(_this__u8e3s4, comparator);
}
function distinctBy(_this__u8e3s4, selector) {
  return new (DistinctSequence())(_this__u8e3s4, selector);
}
function toMutableList(_this__u8e3s4) {
  return toCollection(_this__u8e3s4, ArrayList().w());
}
function toCollection(_this__u8e3s4, destination) {
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    destination.v(item);
  }
  return destination;
}
function *_generator_invoke__zhh2q8($this, $this$result, $completion) {
  var iterator = $this.o2_1.m1();
  if (!iterator.n1())
    return Unit_instance;
  var current = iterator.o1();
  while (iterator.n1()) {
    var next = iterator.o1();
    var tmp = $this$result.q2($this.p2_1(current, next), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    current = next;
  }
  return Unit_instance;
}
var zipWithNext$slambdaClass;
function zipWithNext$slambda() {
  if (zipWithNext$slambdaClass === VOID) {
    class $ {
      constructor($this_zipWithNext, $transform) {
        this.o2_1 = $this_zipWithNext;
        this.p2_1 = $transform;
      }
      r2($this$result, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$result), $completion);
      }
      s2(p1, $completion) {
        return this.r2(p1 instanceof SequenceScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    zipWithNext$slambdaClass = $;
  }
  return zipWithNext$slambdaClass;
}
function zipWithNext$slambda_0($this_zipWithNext, $transform) {
  var i = new (zipWithNext$slambda())($this_zipWithNext, $transform);
  var l = ($this$result, $completion) => i.r2($this$result, $completion);
  l.$arity = 1;
  return l;
}
function Sequence$iterator$ref() {
  var l = (p0) => p0.m1();
  l.callableName = 'iterator';
  return l;
}
var asIterable$$inlined$Iterable$1Class;
function asIterable$$inlined$Iterable$1() {
  if (asIterable$$inlined$Iterable$1Class === VOID) {
    class $ {
      constructor($this_asIterable) {
        this.t2_1 = $this_asIterable;
      }
      m1() {
        return this.t2_1.m1();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Iterable()]);
    asIterable$$inlined$Iterable$1Class = $;
  }
  return asIterable$$inlined$Iterable$1Class;
}
function filterNotNull$lambda(it) {
  return it == null;
}
function distinct$lambda(it) {
  return it;
}
function Iterable$iterator$ref() {
  var l = (p0) => p0.m1();
  l.callableName = 'iterator';
  return l;
}
var sortedWith$1Class;
function sortedWith$1() {
  if (sortedWith$1Class === VOID) {
    class $ {
      constructor($this_sortedWith, $comparator) {
        this.u2_1 = $this_sortedWith;
        this.v2_1 = $comparator;
      }
      m1() {
        var sortedList = toMutableList(this.u2_1);
        sortWith(sortedList, this.v2_1);
        return sortedList.m1();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Sequence()]);
    sortedWith$1Class = $;
  }
  return sortedWith$1Class;
}
//region block: exports
export {
  asIterable as asIterable1fxmj7vyh9cyo,
  distinct as distinct17vua5ffe1cfv,
  filter as filter184huxd00uyfg,
  firstOrNull as firstOrNull175qkyx53x0vd,
  flatMap as flatMapgxtanzi5fvh9,
  flatMap_0 as flatMap1gb3cjy1dqv3d,
  joinToString as joinToStringooja5rkatz3u,
  mapNotNull as mapNotNull3b8ce5hky4k2l,
  map as mapsbvh18eqox7a,
  maxOrNull as maxOrNull2yp8rzwwvng8y,
  sortedWith as sortedWith249tsu0292gn1,
  sum as sum21i2pabt6cxsw,
  take as take2rh6pen3z50h7,
  toList as toListx6x8nvfmvvht,
  toSet as toSet2morh2kqexfa2,
  zipWithNext as zipWithNext1coaflhq3atps,
};
//endregion

//# sourceMappingURL=_Sequences.mjs.map
